import {
  Typography,
  Button,
  Stack,
  TextField
} from '@mui/material'
import { getAddress, Address } from 'jposta'
import { isEmpty } from 'lodash'
import { isNil } from 'lodash/fp'
import { ChangeEvent, useEffect, useState } from 'react'
import log from 'loglevel'
import { inspect } from '../../inspect'
import { useFormContext } from 'react-hook-form'

export const CommonAddressForm = (props: {
  label: string
  postalCode: string
  forms: {
    setters: Record<string, (value: React.SetStateAction<any>) => void>
    formDatas: Record<string, string>
  }
}) => {
  const { label, postalCode, forms } = props
  const { setters, formDatas } = forms
  const { pref, city, town, place } = formDatas
  const { setPref, setCity, setTown, setPostalCode, setPlace } = setters
  const {
    register,
    formState: { errors },
    setValue
  } = useFormContext()
  const [complement, setComplement] = useState<Address | undefined>(undefined)
  useEffect(() => {
    if (isNil(complement)) return
    const { pref, city, area } = complement
    setPref(pref)
    setValue('pref', pref)
    setCity(city)
    setValue('city', city)
    setTown(!isNil(area) ? area : '')
    setValue('town', !isNil(area) ? area : '')
  }, [complement])

  const handleChangePostalCode = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setPostalCode)) {
      return
    }
    setPostalCode(event.currentTarget.value)
  }
  const handleClickPostalCodeButton = () => {

    if (!isEmpty(postalCode)) {
      getAddress(postalCode).then((response) => {
        if (isNil(response)) {
          log.error(
            '[index.handleClickPostalCodeButton]',
            inspect({ postalCode })
          )
          return
        } else {
          setComplement(response)
        }
      })
    }
  }
  const handleChangePref = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setPref)) {
      return
    }
    setPref(event.currentTarget.value)
  }
  const handleChangeCity = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setCity)) {
      return
    }
    setCity(event.currentTarget.value)
  }
  const handleChangeTown = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setTown)) {
      return
    }
    setTown(event.currentTarget.value)
  }
  const handleChangePlace = (event: ChangeEvent<HTMLInputElement>) => {
    if (isNil(setPlace)) {
      return
    }
    setPlace(event.currentTarget.value)
  }
  return (
    <>
      <Typography variant="subtitle1">
        <Typography component={'span'} color="red">
          *
        </Typography>
        <Typography component={'span'} sx={{ ml: 1 }}>
          郵便番号（半角 ハイフンあり）
        </Typography>
      </Typography>
      <Stack spacing={3} direction="row" useFlexGap>
        <TextField
          id="postalCode"
          {...register('postalCode')}
          error={'postalCode' in errors}
          helperText={errors.postalCode?.message as string}
          onChange={handleChangePostalCode}
          defaultValue={postalCode}
          label="郵便番号（半角　ハイフンあり）"
          placeholder="123-4567"
          required
          variant="filled"
          size={'small'}
          margin="dense"></TextField>
        <Button
          id="postalCodeButton"
          variant='outlined'
          size={'small'}
          onClick={handleClickPostalCodeButton}>
          <Typography>{label}</Typography>
        </Button>
      </Stack>
      <Typography variant="subtitle1">住所</Typography>
      <Typography variant="subtitle1">
        <Typography component={'span'} color="red">
          *
        </Typography>
        <Typography component={'span'} sx={{ ml: 1 }}>
          都道府県
        </Typography>
      </Typography>
      <Stack spacing={3} direction="row">
        <TextField
          id="pref"
          {...register('pref')}
          error={'pref' in errors}
          helperText={errors.pref?.message as string}
          onChange={handleChangePref}
          value={pref}
          label="都道府県"
          placeholder="例）愛知県"
          required
          variant="filled"
          size={'small'}></TextField>
      </Stack>
      <Typography variant="subtitle1">
        <Typography component={'span'} color="red">
          *
        </Typography>
        <Typography component={'span'} sx={{ ml: 1 }}>
          市区町村
        </Typography>
      </Typography>
      <Stack spacing={3} direction="row">
        <TextField
          id="city"
          {...register('city')}
          error={'city' in errors}
          helperText={errors.city?.message as string}
          onChange={handleChangeCity}
          value={city}
          label="市区町村"
          placeholder="例）名古屋市中区"
          required
          variant="filled"
          fullWidth></TextField>
      </Stack>
      <Typography variant="subtitle1">
        <Typography component={'span'} color="red">
          *
        </Typography>
        <Typography component={'span'} sx={{ ml: 1 }}>
          {!isNil(place)
            ? '町域・番地（全角）'
            : '町域・番地・建物名・部屋番号（全角）'}
        </Typography>
      </Typography>
      <Stack spacing={3} direction="row">
        <TextField
          id="town"
          {...register('town')}
          error={'town' in errors}
          helperText={errors.town?.message as string}
          onChange={handleChangeTown}
          value={town}
          label={
            !isNil(place)
              ? '町域・番地（全角）'
              : '町域・番地・建物名・部屋番号（全角）'
          }
          placeholder="例）栄４−５−３"
          required
          variant="filled"
          fullWidth></TextField>
      </Stack>
      {!isNil(place) ? (
        <>
          <Typography variant="subtitle1">
            <Typography component={'span'} sx={{ ml: 1 }}>
              建物名・部屋番号（全角）
            </Typography>
          </Typography>
          <Stack spacing={3} direction="row">
            <TextField
              id="place"
              {...register('place')}
              error={'place' in errors}
              helperText={errors.place?.message as string}
              onChange={handleChangePlace}
              defaultValue={place}
              label="建物名・部屋番号（全角）"
              placeholder="例）ＫＤＸ名古屋栄ビル９Ｆ"
              variant="filled"
              fullWidth></TextField>
          </Stack>
        </>
      ) : (
        <></>
      )}
    </>
  )
}
